import GlobalConfig from "~/content/data/config.json"
export default function (page,app) {

  const head = {
    title: page?.title ?? GlobalConfig.title ?? 'Burst SMS',
    meta: [],
    script: [
      {
        type: 'application/ld+json',
        json: {
          "@context": "https://schema.org",
          "@type": "LocalBusiness",
          "image": [
            "https://burstsms.com/uploads/burst-sms-logo.jpg"
          ],
          "@id": "https://burstsms.com",
          "url": "https://burstsms.com",
          "name": "Burst SMS",
          "address": {
            "@type": "PostalAddress",
            "streetAddress": "Suite 2, Level 10 60 Carrington Street",
            "addressLocality": "Sydney",
            "addressRegion": "NSW",
            "postalCode": "2000",
            "addressCountry": "Australia"
          },
          "description": "America's Premier Online SMS Software for Business Messaging",
          "priceRange": "https://burstsms.com/pricing/",
          "telephone": "18884260999"
        }
      }
    ],
    link: []
  };

  const options = {
    url: "https://burstsms.com",
    title: page.title ?? GlobalConfig.title ?? 'Burst SMS',
    site_name: "Burst SMS",
    description: page.description || GlobalConfig.description,
    img: "https://burstsms.com/uploads/burstsms-au.png",
    locale: "en_US",
    twitter: "@burstsms",
    twitter_card: "summary_large_image",
    themeColor: "#00aec4",
  };
  let keywords = GlobalConfig.keywords;

  if(page.keywords && page.keywords.length > 0)
    keywords = page.keywords

  const metaTags = [

    { name: 'description', content: options.description },
    { name: 'keywords', content: keywords.join(', ') },
    // Global
    { name: "author", content: options.url },
    { name: "publisher", content: options.url },
    { name: "apple-mobile-web-app-title", content: options.title },
    { name: "theme-color", content: options.themeColor },

    // Facebook & LinkedIn
    { property: "og:title", content: options.title },
    { property: "og:description", content: options.description },
    { property: "og:type", content: "website" },
    { property: "og:url", content: options.url },
    { property: "og:image", content: options.img },
    { property: "og:locale", content: options.locale },
    { property: "og:site_name", content: options.site_name },

    // Twitter
    { name: "twitter:card", content: options.twitter_card },
    { name: "twitter:site", content: options.twitter },
    { name: "twitter:creator", content: options.twitter },
    { name: "twitter:title", content: options.title },
    { name: "twitter:description", content: options.description },
    { name: "twitter:image", content: options.img },
  ];

  metaTags.forEach((tag) => {
    if (tag.content !== undefined && tag.content !== null) {
      if (tag.hasOwnProperty("name")) {
        head.meta.push({
          hid: tag.name,
          name: tag.name,
          content: tag.content,
        });
      }else if(tag.hasOwnProperty("property")){
        head.meta.push({
          hid: tag.property,
          property: tag.property,
          content: tag.content,
        });
      }
    }
  });

  const noindex = [
    '/au/index',
    '/us/index',
    '/pages/404',
    '/pages/unavailable',
    '/pages/research-survey',
    '/pages/a',
    '/pages/b',
    '/pages/c',
    '/pages/d',
    '/pages/e',
    '/pages/f',
    '/pages/us-a',
    '/pages/us-b',
    '/pages/us-c',
    '/pages/us-d',
    '/pages/us-f',
    '/pages/referral',
    '/pages/referrals',
    '/pages/refer',
    '/pages/au-sms-marketing-eofy23',
    '/pages/au-sms-tall-savings-offer',
    '/pages/au-sms-marketing-eofy23-terms',
    '/pages/au-sms-offer-eofy23',
    '/pages/au-sms-offer-eofy25',
    '/pages/au-sms-marketing-eofy-thank-you',
    '/pages/nz-sms-marketing-eofy23',
    '/pages/nz-sms-tall-savings-offer',
    '/pages/nz-sms-offer-eofy23',
    '/pages/nz-sms-marketing-eofy-thank-you',
    '/pages/us-sms-marketing-eofy23',
    '/pages/us-sms-offer-eofy23',
    '/pages/us-sms-marketing-eofy-thank-you',
    '/pages/au-b2b-marketers-bonus-credit23',
    '/pages/ra-bonus-offer',
    '/pages/au-sms-blast-bfcm-v1',
    '/pages/au-sms-blast-bfcm-v2',
    '/pages/au-sms-blast-bfcm-v3',
    '/pages/us-sms-blast-bfcm-v1',
    '/pages/us-sms-blast-bfcm-v2',
    '/pages/nz-sms-blast-bfcm-v1',
    '/pages/nz-sms-blast-bfcm-v2',
    '/pages/ph-sms-blast-bfcm-v1',
    '/pages/ph-sms-blast-bfcm-v2',
    '/pages/ph-sms-blast-bfcm-v3',
    '/pages/us-sms-marketing',
    '/pages/us-text-marketing',
  ];

  let indexing = true;

  for (let i = 0; i < noindex.length; i++) {

    if(page.path === noindex[i]){
      indexing = false;
      head.meta.push({ hid: 'robots', name: 'robots', content: 'noindex' });
      head.meta.push({ hid: 'googlebot', name: 'googlebot', content: 'noindex' });
      break;
    }
  }

  if (indexing && page.path) {
    // let slug = `${page?.slug ?? ''}/`;

    let slug = page.path
      .replace('/pages','')
      .replace('/index', '')

    // if(page.path === '/pages/index') slug = '';
    // if(page.path === '/legal/privacy-policy') slug = 'legal/privacy-policy/';
    // if(page.path === '/legal/terms') slug = 'legal/terms/';
    // if(page.path === '/legal/service-level-agreement') slug = 'legal/service-level-agreement/';
    if(page.path === '/pages/sms-marketing-black-friday') slug = '/sms-marketing-sales';
    if(page.path === '/pages/sms-marketing-newsletter') slug = '/sms-marketing-sales';

    head.link.push({
      rel: 'canonical',
      href: `https://burstsms.com${slug}/`
    });
  }

  return head;
}
